import React, { useEffect } from 'react';
import { MdCheckCircle } from 'react-icons/md';

export type ToastType = 'success' | 'error' | 'warning' | 'info';

interface ToastProps {
  message: string;
  type: ToastType;
  onClose: () => void;
  duration?: number;
}

const Toast: React.FC<ToastProps> = ({ message, type, onClose, duration = 3000 }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  const config = {
    success: {
      icon: MdCheckCircle,
      bgColor: 'bg-green-500',
      textColor: 'text-white',
    },
    error: {
      icon: MdCheckCircle,
      bgColor: 'bg-red-500',
      textColor: 'text-white',
    },
    warning: {
      icon: MdCheckCircle,
      bgColor: 'bg-orange-500',
      textColor: 'text-white',
    },
    info: {
      icon: MdCheckCircle,
      bgColor: 'bg-blue-500',
      textColor: 'text-white',
    },
  };

  const Icon = config[type].icon;

  return (
    <div className="fixed top-4 right-4 z-[9999] animate-slideIn">
      <div
        className={`flex items-center gap-3 rounded-lg ${config[type].bgColor} ${config[type].textColor} px-6 py-4 shadow-2xl min-w-[300px] max-w-md`}
      >
        <Icon className="h-6 w-6 flex-shrink-0" />
        <p className="flex-1 text-sm font-medium">{message}</p>
        <button
          onClick={onClose}
          className="flex-shrink-0 rounded-full p-1 hover:bg-white/20 transition text-lg font-bold"
        >
          ×
        </button>
      </div>
    </div>
  );
};

export default Toast;
